// Brand assets for Legacy India Travel
export const LOGO_URL = "/legacy-india-travel-logo.webp";
